import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { translate } from '../../../utils/Common';
import Button from '../../../components/common/Button';
import * as FaIcons from 'react-icons/fa';

const ClientActions = ({ client }) => {
  const history = useHistory();

  const handleView = (e) => {
    e.stopPropagation(); // Prevenir que se active el onRowClick de la tabla
    const clientId = client?.IdCliente || client?.id;
    if (clientId) {
      history.push(`/dashboard/clients/details/${clientId}`);
    }
  };

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={handleView}
      leftIcon={<FaIcons.FaEye size={14} />}
      title={translate('dashboard.clients.tooltips.viewDetails')}
      aria-label={translate('dashboard.clients.tooltips.viewDetails')}
    >
      {translate('global.view')}
    </Button>
  );
};

ClientActions.propTypes = {
  client: PropTypes.object.isRequired,
};

export default ClientActions;

